import * as React from 'react';
import c from 'classnames';

import { Icon, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

type Props = {
  title: string,
  subtitle?: string,
  link: string,
  imageUrl?: string,
  icon?: string,
  titleClassName?: string,
};

const LinkListPrimaryItem: React.FC<Props> = (props) => {
  const {
    title,
    subtitle,
    link,
    imageUrl,
    icon,
    titleClassName,
  } = props;

  const titleClasses = c('LinkListItem__title', titleClassName);
  const classes = c('LinkListItem');

  return (
    <li>
      <CoreLink to={link} title={title} className={classes}>

        {imageUrl && (
          <div className="LinkListItem__image">
            <Image src={imageUrl} alt={title} />
          </div>
        )}

        <div className="LinkListItem__content">
          <div className={titleClasses}>
            {title}
          </div>

          {subtitle && (
            <div className="LinkListItem__subtitle">
              <span>{subtitle}</span>
              {icon && <Icon name="arrow" />}
            </div>
          )}
        </div>

      </CoreLink>
    </li>
  );
};

export default LinkListPrimaryItem;
